import * as Sentry from '@sentry/browser';
import { captureConsoleIntegration } from '@sentry/core';

// ----------------------------------------------------------------------

const DSN = import.meta.env.VITE_GLITCHTIP_DSN as string | undefined;

/**
 * Initialise GlitchTip / Sentry error monitoring.
 * Safe to call before oidcEarlyInit — the SDK only registers event listeners
 * during init and never makes a network request until an event is captured.
 *
 * Call this as the very first thing in main.ts.
 *
 * No-op when VITE_GLITCHTIP_DSN is empty or undefined (e.g. self environment).
 */
export function initMonitoring() {
  if (!DSN) return;
  // Skip during local development — dev builds generate too much noise.
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: DSN,
    // VITE_APP_ENV is set per deploy target (prod | dev | self).
    // Falls back to Vite's MODE ('development' | 'production') for local runs.
    environment: (import.meta.env.VITE_APP_ENV as string | undefined) ?? import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    integrations: [
      // Capture console.warn and console.error as GlitchTip events.
      // console.log / console.info are intentionally excluded to avoid noise.
      captureConsoleIntegration({ levels: ['warn', 'error'] }),
    ],
  });
}
